<div class="login_page">
  <div class="container-fluid">
    <div class="login-wrapper row">
      <div id="login" class="login loginpage col-lg-offset-4 col-md-offset-3 col-sm-offset-3 col-xs-offset-0 col-xs-12 col-sm-6 col-lg-4">
        <h1><a title="Login Page" tabindex="-1">Portal Admin</a></h1>


        <!--<h3 class="message">
          eviewPlus for Cromwell and St John and Elizabeth hospitals
          have now been migrated to dedicated applications, here:
        </h3>

        <p><a href="https://cromeview.tdlpathology.com"> https://cromeview.tdlpathology.com </a></p>
        <p><a href="https://hjeeview.tdlpathology.com">  https://hjeeview.tdlpathology.com </a></p>-->


        <form name="loginform" id="loginform" [formGroup]="loginForm" (ngSubmit)="login(loginForm.value)" autocomplete="off">
          <div class="label-danger row message" *ngIf="errorMessage">
            <label> {{errorMessage}}</label>
          </div>


          <p>
            <label for="userName">
              Username<br />
              <input type="text" formControlName="userName" id="userName" class="input" name="userName" size="20" />
              <em *ngIf="loginForm.controls.userName.invalid&&loginForm.controls.userName.touched" class="text-danger">Required</em>
            </label>
          </p>

          <p>
            <label for="pwd">
              Password<br />
              <input type="password" id="pwd" autocomplete="off" class="input" formControlName="password" name="password" size="20" />
              <em *ngIf="loginForm.controls.password.invalid&&loginForm.controls.password.touched" class="text-danger">Required</em>

            </label>
          </p>


          <p class="submit">
            <input type="submit" name="submit" id="submit" class="btn btn-accent btn-block" [disabled]="!loginForm.valid" value="Sign In" />
          </p>

        </form>
        <p>
          <a class="pull-left" routerLink="/password-reset">Forgotten password?</a>
        </p>

      </div>
    </div>
  </div>
</div>
